import React from 'react';
import PropTypes from 'prop-types';

const BoldText = ({ text, boldPart }) => {
  // Ensure boldPart is an array to handle both cases (string or array)
  const boldParts = Array.isArray(boldPart) ? boldPart.filter(Boolean) : [boldPart].filter(Boolean);

  const renderText = () => {
    if (boldParts.length > 0) {
      // Escape special regex characters in bold parts and create the regex pattern
      const escapedBoldParts = boldParts.map((part) => part.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'));
      const regex = new RegExp(`(${escapedBoldParts.join('|')})`, 'gi');
      const parts = text.split(regex);

      // Split the text by the bold parts and map them accordingly
      return parts.map((part, index) =>
        boldParts.some((b) => b.toLowerCase() === part.toLowerCase()) ? (
          <React.Fragment key={index}>
            {index !== 0 ? '\u00A0' : ''}
            <span style={{ fontWeight: 'bold' }}>{part}</span>
            {index !== text.length - 1 && !/^[.!?]/.test(parts[index + 1]) ? '\u00A0' : ''}
          </React.Fragment>
        ) : (
          <React.Fragment key={index}>{part.trim()}</React.Fragment>
        )
      );
    }

    return <span style={{ fontWeight: 'bold' }}>{text}</span>;
  };

  return renderText();
};

BoldText.propTypes = {
  text: PropTypes.string.isRequired,
  boldPart: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired
};

export { BoldText };
